import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import './Createaccountform.scss';
import InputLabel from '@mui/material/InputLabel';
import LocationsModal from '../locationsmodal/LocationsModal';
import { FORM_FOOTER_SUB_TEXT1, FORM_FOOTER_SUB_TEXT2, FORM_FOOTER_SUB_TEXT3, FORM_FOOTER_SUB_TEXT4, FORM_FOOTER_SUB_TEXT5, FORM_FOOTER_TEXT, CREATEACCOUNT_TEXT, BUSINESS_TEXT, LOCATION_TEXT, VIEW_LOCATION_TEXT, USERNAMEERR_TEXT, EMAILERR_TEXT, AGGRERR_TEXT, BRANDERR_TEXT, FORM_SERVER_ERR, BRAND_TEXT, AGGREGATOR_TEXT, PASSWORD_TEXT, PASSWORD_SUB_TEXT, DETAILS_TEXT, MERCHANT_MESSAGE, MERCHANT_SUB_TEXT} from '../../../../constants/Admin/adminConstants';
import CreateAccountButton from '../createaccountbutton/createaccountbutton';
import { createAccountRequest, createAccountSuccess } from '../../../../redux/actions/adminFlow/createAccountAction';
import { selectedBrandId, selectedBrandNames,selectedAggregators, selectLocations, selectBusinessName } from '../../../../redux/saga/adminFlow/merchantInfoSelector';
import { activeusername,activeemail } from '../../../../redux/actions/adminFlow/merchantInfoAction';
import { selectCreateAccountResponseData, selectCreateAccountError } from '../../../../redux/saga/adminFlow/createAccountSelector';
import CustomStatusPage from '../../../../shared/pages/custom.status';

const Createaccountform = () => {

	const dispatch = useDispatch();

	const [email, setEmail] = useState('');
	const [username, setUsername] = useState('');
	const [brandselection, setBrandSelection] = useState('');
	const [aggregatorselection, setAggregatorSelection] = useState('');
	const [emailError, setEmailError] = useState(false);
	const [usernameError, setUsernameError] = useState(false);
	const [brandselectionError, setbrandSelectionError] = useState(false);
	const [aggregatorselectionError, setaggregatorSelectionError] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
	const [isFormValid, setIsFormValid] = useState(false);
	const [errormsg, seterrormsg]= useState('');
	const [createaccservererror, setcreateaccservererror]= useState(false);
	const [selectedIndex, setSelectedIndex] = useState(0);
	const createaccountsuccess = useSelector(selectCreateAccountResponseData);

	const createaccountError = useSelector(selectCreateAccountError);
	const brandId = useSelector(selectedBrandId);

	const aggregatorlist =  useSelector(selectedAggregators);
	let activeaggregators =  aggregatorlist ? aggregatorlist.aggregators : null;
	if ((activeaggregators === undefined) || (activeaggregators === null)){
			activeaggregators = sessionStorage.getItem('saveAggregatorValues'); 
	}

	const brandnameslist =  useSelector(selectedBrandNames);
	let activebrandnames =  brandnameslist ? brandnameslist.brandname : null;
	if ((activebrandnames === undefined) || (activebrandnames === null)){
			activebrandnames = sessionStorage.getItem('activebrandnames'); 
	}

	const locationscount = useSelector(selectLocations);
	let activelocationscount =  locationscount ? locationscount.locations : null;
	if ((activelocationscount === undefined) || (activelocationscount === null)){
			activelocationscount = sessionStorage.getItem('activelocationscount'); 
	}

	const businessName = useSelector(selectBusinessName);
	let activebusinessName=  businessName ? businessName.businessName : null;
	if ((activebusinessName === undefined) || (activebusinessName === null)){
			activebusinessName = sessionStorage.getItem('activebusinessname');
	}

	const handleOpenModal = () => {
		setModalOpen(true);
	};

	const handleCloseModal = () => {
		setModalOpen(false);
	};

	useEffect(() => {
		dispatch(createAccountSuccess(null));
		
		setSelectedIndex(2);
		
		if (createaccountError && createaccountError.error.response) {
			//const ACCcreationfailederror = createaccountError.error.response.data.message;
			const errorStatusCode = createaccountError.error.response.status;
			if (errorStatusCode && (errorStatusCode === 400)) { 
				seterrormsg(createaccountError.error.response.data.message);
					// if (ACCcreationfailederror.includes('User account already exists')) { // this condition for USER ALREADY EXISTS
					// 	seterrormsg(createaccountError.error.response.data.message);
					// }
					// else if(ACCcreationfailederror.includes('Exceeded daily email limit')){
					// 	seterrormsg(createaccountError.error.response.data.message);
					// }else{
					// 	seterrormsg(createaccountError.error.response.data.message);
					// }
			}
			else if(createaccountError.error.response.status === 500){
				setcreateaccservererror(true);
			}else{}

		//if (ACCcreationfailederror){
		//   if (ACCcreationfailederror.includes('User account already exists')) {
		// 	//setUsernameError('User account already exists');
		// 	seterrormsg(createaccountError.error.message);
		//   }
		} else {
			setUsernameError(false); 
			seterrormsg('');// Reset the email error if there's no error
		}
	}, [createaccountError]);


	useEffect(() => {
		if (email !=='' && username !=='' && aggregatorselection !=='' && brandselection!=='' && !emailError && !usernameError && !brandselectionError && !aggregatorselectionError) {
			// All errors are resolved, submit the form
			handleSubmit();
		}
	}, [emailError, usernameError, brandselectionError, aggregatorselectionError]);

	const checkFormValidity = () => {
		const isEmailValid = email.includes('@') && email.trim() !== '';
		const specialCharRegex = /[./$'"><&|()=;]/;
		const isUsernameValid = username.length >= 3 && !specialCharRegex.test(username) && username.trim() !== '';
		const isBrandSelectionValid = brandselection !== '';
		const isAggregatorSelectionValid = aggregatorselection !== '';
		setIsFormValid(isEmailValid && isUsernameValid && isBrandSelectionValid && isAggregatorSelectionValid);
	};

	useEffect(() => {
		checkFormValidity();
		}, [email, username, brandselection, aggregatorselection]);

	const handleEmailChange = (e) => {
		const newEmail = e.target.value;
		setEmail(newEmail);
		setEmailError(!newEmail.includes('@'));
	};
  
	const handleUsernameChange = (e) => {
		const newUsername = e.target.value;
		setUsername(newUsername);
		const specialCharRegex = /[./$'"><&|()=;]/;
		setUsernameError(newUsername.length < 3 || specialCharRegex.test(newUsername));
	};
	
	const handleBrandChange = (e) => {
		const newBrand = e.target.value;
		setBrandSelection(newBrand);
		setbrandSelectionError(newBrand === '');
	};
	
	const handleAggregatorChange = (e) => {
		const newAggregator = e.target.value;
		setAggregatorSelection(newAggregator);
		setaggregatorSelectionError(newAggregator === '');
	};

	const handleSubmit = (e) => {      // createaccount formsubmit
		if (e) {
			e.preventDefault();
		}
		const specialCharRegex = /[./$'"><&|()=;]/;
		const isEmailValid = email.includes('@'); // Validate email
		setEmailError(!isEmailValid);
		seterrormsg('');
		const isUsernameLengthValid = username.length >= 3;  // Validate username
		const isUsernameContentValid = !specialCharRegex.test(username); // Validate username content
		const isUsernameValid = isUsernameLengthValid && isUsernameContentValid;
		setUsernameError(!isUsernameValid);
		const isBrandSelectionValid = brandselection !== '';  // Validate brand selection
		setbrandSelectionError(!isBrandSelectionValid);
		const isAggregatorSelectionValid = aggregatorselection !== '';  // Validate aggregator selection
		setaggregatorSelectionError(!isAggregatorSelectionValid);
	
		// If all validations pass, submit the form
		if (isEmailValid && isUsernameValid && isBrandSelectionValid && isAggregatorSelectionValid) {
			dispatch(activeusername(username));
			dispatch(activeemail(email));
			const formData = {
				'userName': username,
				'emailId': email,
				'brandId': brandId.brandid,
				'brand': brandselection,
				'aggregator':aggregatorselection
			};
			try {
				dispatch(createAccountRequest(formData));
			} catch (error) {
				console.error('Error submitting form:', error);
			}
		}
	};
 
	return (

		<div className='create-account'>

			<Paper className='create-account-header' >
				<h4 className='create-account-title text-align-left' data-testid='createAccText'>{CREATEACCOUNT_TEXT}</h4>
			</Paper>
			
			{(createaccountsuccess && (createaccountsuccess?.data) !== null)&& 
				<CustomStatusPage statusIndicator='User_Created_Admin'>
				</CustomStatusPage>
			}

			{(createaccountsuccess) && (createaccountsuccess?.data ===null) && (!createaccservererror) && (<div className='create-account-formsection'>
				<form onSubmit={handleSubmit}>
					
					<Paper className='create-account-body'>
						<h4 className='create-account-body-title text-align-left'>{CREATEACCOUNT_TEXT}</h4>
					</Paper>

			
				<Paper className='create-account-body-form'>

					<h4 className='text-align-left'> {BUSINESS_TEXT}</h4>
					<div className='create-account-body-text text-align-left'> {activebusinessName} </div>

					<div className='location-section'>
						<h4 className='text-align-left'> {LOCATION_TEXT} </h4>
						<div className='locations-block' data-testid='viewLocationText' ><a href='#' onClick={handleOpenModal}  > {VIEW_LOCATION_TEXT}</a>
							<span className='locations-count'>({activelocationscount})</span>
						</div>
						<LocationsModal open={modalOpen} onClose={handleCloseModal} />
					</div>

					<div className='form-section'>

						<FormControl>
							<Grid container>
								<Grid item xs={6}>
									<TextField type='email' label='Business Email' size='normal' value={email} data-testid='businessEmail'
												onChange={handleEmailChange}
												error={emailError} helperText={emailError ? EMAILERR_TEXT : ''}/>
								</Grid>
								<Grid item xs={6}>
									<TextField label='Username'
												id='username'
												name='username'
												variant='outlined'
												fullWidth data-testid='Username'
												value={username}
												onChange={handleUsernameChange}
												error={usernameError}
												helperText={usernameError ? USERNAMEERR_TEXT : ''} />
								</Grid>
							</Grid>
							<Grid container>
								<Grid item xs={6}>
									<FormControl fullWidth>
										<InputLabel>{BRAND_TEXT}</InputLabel>
										<Select
											value={brandselection} id='brandSelection' data-testid='Brand'
											onChange={handleBrandChange}
											variant='outlined'
											displayEmpty
											error={brandselectionError}
										>
											<MenuItem  value='' disabled></MenuItem>
											<MenuItem value={activebrandnames}>{activebrandnames}</MenuItem>
										</Select>
										{brandselectionError && <span className='error-message'>{BRANDERR_TEXT}</span>}
									</FormControl>
								</Grid>
								<Grid item xs={6}>
										<FormControl>
											<InputLabel>{AGGREGATOR_TEXT}</InputLabel>
												<Select
													value={aggregatorselection} id='aggregatorSelection' data-testid='Aggregator'
													onChange={handleAggregatorChange}
													variant='outlined'
													displayEmpty
													error={aggregatorselectionError}
												>
													<MenuItem value='' disabled></MenuItem>
													<MenuItem  value={activeaggregators}>{activeaggregators}</MenuItem>
												</Select>
												{aggregatorselectionError && <span className='error-message'>{AGGRERR_TEXT}</span>}
										</FormControl>
								</Grid>
							</Grid> 
						</FormControl>	
						
						<div className='password-label'>
							<h4 className='text-align-left'> {PASSWORD_TEXT}</h4>
							<div className='create-account-body-text text-align-left'> {PASSWORD_SUB_TEXT}</div>
						</div>
						<div className='error-msg'>{errormsg}</div>

					</div>
				</Paper>
				<Paper className='button-section' data-testid='button'>
					<CreateAccountButton disable={!isFormValid}/>
				</Paper>
				</form>
				<div className='create-account-footer'>
					<Paper className='footer-section'>
						<h4 className='create-account-footer-title text-align-left'>{DETAILS_TEXT}</h4>
					</Paper>
					<Paper className='footer-content'>
						<h4 className='create-account-footer-subtitle text-align-left'>{MERCHANT_MESSAGE}</h4>
						<p className='text text-align-left'> {MERCHANT_SUB_TEXT} </p>
						<h4 className='create-account-footer-subtitle text-align-left'>{FORM_FOOTER_TEXT}</h4>
						<ul>
							<li>{FORM_FOOTER_SUB_TEXT1}</li>
							<li>{FORM_FOOTER_SUB_TEXT2}</li>
							<li>{FORM_FOOTER_SUB_TEXT3}</li>
							<li>{FORM_FOOTER_SUB_TEXT4}</li>
							<li>{FORM_FOOTER_SUB_TEXT5}</li>
						</ul>
					</Paper>
				</div>
			</div>)} 

			{createaccservererror &&  ((createaccountsuccess.data) === null ) &&
			<CustomStatusPage statusIndicator='User_Created_Admin_Servererror'>
			</CustomStatusPage>}
			
		</div>

	);
};

export default Createaccountform;
